export default {
  10001: 'ユーザー名またはメールアドレスを入力してください',
  10002: 'メールアドレスが間違って入力されました',
  10003: 'ユーザー名入力エラー',
  10004: 'パスワードが間違って入力されました',
  10005: '異常なユーザー状態',
  10006: 'ユーザー名は既に存在します',
  10007: 'メールは既に存在します',
  10008: 'ユーザーステータスが間違っています',
  10009: '該当するユーザーが見つかりませんでした',
  10010: 'Expert Advisor 製品が正しくありません',
  10011:
    'ユーザーの残高が不足している場合は、購入する前にチャージまたはデポジットを解除してください。',
  10012: '該当する日が見つかりませんでした',
  10013: '投資額が間違っている',
  10014: '量化決済商品が正しくありません',
  10015: '現在取引できません',
  10016: '購入金額が間違っている',
  10017: '該当する期間が見つかりませんでした',
  10018: 'システムパラメータの取得に失敗しました',
  10019: 'このユーザーの現在の認証ステータスは正しくありません',
  10020: '収集ステータスが正しくありません',
  10021: '受信アドレスが入力されていません',
  10022: 'ユーザーが認証されていません',
  10023: '貸出期間の設定が間違っている',
  10024: 'すでに同じ商品を購入されていますので、再度購入しないでください。',
  10025: '出金方法を選択してください',
  10027: '借入金額は空にできません',
  10028: '借入期間は空にできません',
  10029: '借入金額は0より大きくなければなりません',
  10030: '借入期間の設定が存在しません',
  10031: '借入金額が最低額を下回っています',
  10032: '借入金額が最大額を超えています',
  10033: '借入記録のIDは空にできません',
  10034: '借入記録が存在しません',
  10035: 'この借入記録を操作する権限がありません',
  10036: '借入の状態が返済を許可していません',
  10037: '口座残高が不足しています',
  10094: 'VIPレベルが不足しています。{level}以上のレベルが必要です',
  10095: '投資金額が最大限度額を超過しています',
  10108: '米国株は取引時間外です（東部時間 月〜金 9:30-16:00）。後でもう一度お試しください',
  10109:
    '外国為替/貴金属は取引時間外です（東部時間 日曜17:00〜金曜17:00）。後でもう一度お試しください',
  10110: '取引数量が無効です。0より大きい数量を入力してください',
  20001: 'レビューのための送信が成功しました',
  20002: 'リチャージが正常に追加され、レビューのために送信されました',
  20003: '出金が正常に追加され、審査のために送信されました',
  20004: '購入が成功しました',
  20005: '正常に変更されました',
  20024: 'すでに同じ商品を購入されていますので、再度購入しないでください',
  20094: '出金限度額を超過しました。1人1日1回まで',
  20095: '出金審査中です。重複操作しないでください',
  20102:
    'アカウントは凍結されています。取引と出金は一時的に利用できません。不明点はサポートへお問い合わせください。',
  20103: 'ログインの有効期限が切れました。再度ログインしてください。',
  20104: 'ログインしていません。ログインしてください。',
  Invite: {
    CopyLink: 'リンクをコピー',
    FillInAccount: 'オンラインフォームに記入して取引アカウントを開設',
    Fund: '資金',
    FundYourPrefer: '好きな資金調達方法でアカウントに資金を入れる',
    InviteFriends: '友達を招待',
    InviteYourFriends: '友達を招待',
    Register: '登録',
    StartTradingPlatform: '受賞歴のある取引プラットフォームで取引を開始する',
    Trade: '取引',
    WhenYourRewards:
      '友達や家族を招待して一緒に参加し、金融的繁栄への道のりで一緒に報酬を受け取りましょう！',
  },
  Market: {
    CreateAPlanToTrade: '取引計画を作成',
    ETF: 'ETF',
    ExpectedReturn: '予想リターン',
    LastPrice: '終値',
    Lots: 'ロット',
    OpenPrice: '始値',
    OrderAgain: '再注文',
    OrderNumber: '注文番号',
    Price: '価格',
    Prices: '価格...',
    Sizes: 'サイズ...',
    SpotPrice: '現物価格',
    StopLossPrices: 'ストップロス価格...',
    TakeProfitPrices: '利益確定価格...',
    WantMoreStableEarning: 'より安定した収益が欲しい',
    WhatIsSmartTrading: 'スマート取引とは何か',
    available: '利用可能',
    buy: '買う',
    buyLong: '買い/ロング',
    buyLongBtn: 'ロングバイ',
    chart: 'チャート',
    checkoutSuccess: 'チェックアウト成功',
    close: 'クローズ',
    confirm: '確認',
    contracts: '契約',
    create: '作成',
    cypto: '暗号通貨',
    day: '日',
    down: 'ダウン',
    estimation: '見積もり',
    forex: '外国為替',
    free: '手数料',
    frees: '無料',
    futures: 'コモディティ',
    high: '高い',
    hour: '時間',
    investment: '投資',
    leverage: 'レバレッジ',
    limit: '制限',
    low: '低い',
    market: '市場',
    min: '分',
    mon: '月',
    name: '名前',
    notOpen: '機能はまだオープンしていません',
    open: 'オープン',
    options: '量化決済',
    optionsTime: '量化決済時間',
    orderConfirm: '注文確認',
    requiredMargin: '必要な証拠金',
    return: 'リターン',
    sell: '売る',
    sellShort: '売り/ショート',
    sellShortBtn: 'ショートセール',
    stocks: '株式',
    stopLoss: 'ストップロス',
    stopLossPrice: 'ストップロス価格',
    takeProfit: '利益確定',
    takeProfitPrice: '利益確定価格',
    time: '時間',
    up: 'アップ',
    volume: 'ボリューム',
    watchlist: 'ウォッチリスト',
    week: '週',
  },
  SmartTrading: {
    InterInvestmentAmount: '投資金額を入力...',
    SelectATimeframe: '期間を選択',
    create: '作成',
    createAPlan: '計画を作成',
    dailyYield: '日次利益',
    days: '日数',
    investment: '金額',
    investmentRange: '金額制限',
    product: '製品',
    smrtTrading: 'スマート取引',
    timeframe: '期間',
  },
  aboutUs: {
    about: '私たちについて',
    subtitle1: '会社概要',
    subtitle2: 'パートナー',
    title: '{title}について',
  },
  account: {
    BTCAmount: '金額',
    LOTS: 'ロット',
    LastDigits: '最後の6桁',
    Lots: 'ロット',
    PaymentAmount: '支払金額',
    PleaseUploadSubmission:
      '仮想通貨の支払いのスクリーンショットをアップロードし、提出後に検証を待ってください',
    Preview: 'プレビュー',
    SelectImage: '画像を選択',
    Supports: '対応フォーマット：JPG、JPEG2000、PNG',
    TransactionHash: 'トランザクションハッシュ',
    UploadProof: '証明をアップロードする',
    UploadYourScreenshot: '送金のスクリーンショットをアップロードする',
    accountVerification: 'アカウントの認証',
    address: 'アドレス',
    allOrders: 'すべての注文',
    amount: '金額',
    approved: '承認済み',
    balance: '残高',
    buy: '購入',
    cancel: 'キャンセル',
    changeLanguage: '言語切り替え',
    changePassword: 'パスワード変更',
    close: 'クローズ',
    closePrice: 'クローズ価格',
    closeTime: 'クローズ時間',
    closed: 'クローズ済み',
    contactUs: 'お問い合わせ',
    copyAddress: 'アドレスをコピー',
    copySuccess: '正常にコピーされました',
    cycle: 'サイクル',
    dailyRor: '日次ROR',
    demo: 'デモ',
    deposit: '入金',
    depositWithdraw: '入金・出金',
    down: '下げる',
    downloadPDF: 'PDFダウンロード',
    earlyExist: '早期決済',
    earlyExit: '早期終了',
    earlyExitTip:
      '取引が早期に停止された場合、システムは元本の{num}を自動的に弁済金として差し引き、総収益から差し引かれます',
    expandMore: 'さらに表示',
    expirationTime: '期限切れ時間',
    failed: '失敗',
    freeMargin: '使用マージン',
    futures: '契約',
    helpCenter: 'ヘルプセンター(FAQ)',
    inviteFriends: '友達を招待する',
    lastPrice: '最終価格',
    lever: 'レバレッジ',
    liquidatedDamages: '清算損害金',
    loan: 'ローン',
    logOut: 'ログアウト',
    logoutConfirm: 'ログアウトしますか？',
    margin: '予想利益',
    myAccount: 'マイアカウント',
    notification: '通知',
    notifications: '通知',
    okay: 'OK',
    open: 'オープン',
    openPrice: 'オープン価格',
    openTime: 'オープン時間',
    options: '量化決済',
    optionsOrder: '量化決済注文',
    order: 'オーダー',
    pips: 'pips',
    profit: '利益',
    putAway: '折りたたむ',
    receiveAddress: '受け取りアドレス',
    recreatePlan: 'プランを再作成する',
    refund: '返金',
    refundTip: '資金はライブアカウントに返金されます。確認してください。',
    repayNow: '今すぐ返済',
    repayment: '返済',
    repaymentAmount: '返済額',
    repaymentDate: '返済日',
    repeatOrder: 'この注文を繰り返す',
    reviewed: '審査待ち',
    runTime: '実行時間',
    save: '保存',
    sell: '売る',
    settings: '設定',
    smart: 'スマート',
    startTime: '開始時間',
    staticincome: '定額収益',
    status: 'ステータス',
    success: '成功',
    time: '時間',
    todayEarnings: '今日の収益',
    todayProfit: '今日の利益',
    totalInterest: '累計利息',
    totalProfit: '総利益',
    totalRepayment: '総返済額',
    totalRevenue: '総収益',
    transFees: '取引手数料',
    transRecord: '取引履歴',
    transaction: '取引',
    type: 'タイプ',
    up: '上げる',
    withdraw: '出金',
    withdrawNow: '今すぐ出金',
  },
  bangZhuZhongXin: 'ヘルプセンター',
  biaoDian: '句読点',
  board: {
    content:
      'このソフトウェアは、最高の技術を駆使してプロフェッショナルな方法であなたのすべてのニーズに対応します',
    continue: '続ける',
    skip: 'スキップ',
    title: '最高の取引プラットフォーム',
  },
  bread: {
    introduction: '紹介',
  },
  chaKan: 'チェック',
  chongZhi: '補充する',
  chongZhiJinexiaoYuZuiDiChongZhiJinE: 'チャージ金額が最低チャージ金額を下回っています',
  chongZhiPingZheng: 'リチャージバウチャー',
  chongZhiShiJian: '充電時間',
  chongZhiShuoMing: '充電手順:',
  chongZhiShuoMingUsdtZuiDiChongZhiJinewei_120btcZuiDiChongZhiJinewei_0015ethZuiDiChongZhiJinewei_02:
    '入金手順: USDT の最低入金額は 120、BTC の最低入金額は 0.015、ETH の最低入金額は 0.2 です。',
  close: '閉じる',
  'customerService.error':
    'カスタマーサポートは一時的に利用できません。後でもう一度お試しください。',
  'customerService.close': '閉じる',
  'customerService.connected': '接続済み',
  'customerService.imageAlt': 'サポート画像',
  'customerService.imagePreview': '画像プレビュー',
  'customerService.imageTooLarge': '画像サイズは5MB以下にしてください',
  'customerService.imageTypeUnsupported': 'PNG、JPEG、WebP画像のみ対応しています',
  'customerService.imageUnavailable': '画像を表示できません',
  'customerService.loadFailed':
    'オンラインカスタマーサポートを読み込めませんでした。後でもう一度お試しください。',
  'customerService.loading': '読み込み中…',
  'customerService.loginRequired': 'サポートに連絡するにはログインしてください',
  'customerService.openImage': '画像を開く',
  'customerService.placeholder': 'メッセージを入力し、Enterで送信',
  'customerService.send': '送信',
  'customerService.sendImage': '画像を送信',
  'customerService.reconnecting': '再接続中',
  'customerService.title': 'サポート',
  daDuoShuWangZhanDuHuiCaiQuCuoShiBaoHuYongHuDeGeRenXinXiLiRuShiYongJiaMiJiShuLaiBaoHuMiMa:
    'ほとんどの Web サイトでは、暗号化技術を使用してパスワードを保護するなど、ユーザーの個人情報を保護するための措置を講じています。',
  daDuoShuWangZhanDuYunXuYongHuGengGaiTaMenDeGeRenXinXiLiRuGengGaiDianZiYouJianDiZhiHuoMiMaDanShiMouXieXinXiKeNengWuFaGengGaiLiRuYongHuMing:
    'ほとんどの Web サイトでは、ユーザーは電子メール アドレスやパスワードの変更など、個人情報を変更できます。\nただし、ユーザー名など一部の情報は変更できない場合があります。',
  daiKuanHou_3TianNeiWuXuZhiFuLiXi_3TianHouXuZhiFuLiXi:
    '融資後 {num} 日以内は利息は必要ありませんが、{num} 日後に利息が支払われます。',
  daiShenHe: '審査待ち',
  danShiRuGuoNinShiYongDeWangZhanHuoYingYongChengXuCunZaiAnQuanLouDongNinDeGeRenXinXiKeNengHuiBeiXieLou:
    'ただし、使用する Web サイトやアプリケーションにセキュリティ上の脆弱性がある場合、個人情報が漏洩する可能性があります。',
  dangQiLiRun: '当期利益',
  dangQianLiXi: '現在の興味',
  daoQiHuanXiHuanBen: '期限が来たら利息と元金を返済する',
  daoQiShiJian: '有効期限',
  dengLuChengGong: 'ログイン成功',
  di: '低い',
  dianHuaHaoMa: '電話番号：',
  dieJiaLiShuai: 'オーバーレイ金利:',
  el: {
    cascader: {
      loading: 'Loading',
      noData: 'No data',
      noMatch: 'No matching data',
      placeholder: 'Select',
    },
    colorpicker: {
      clear: 'Clear',
      confirm: 'OK',
    },
    datepicker: {
      cancel: 'Cancel',
      clear: 'Clear',
      confirm: 'OK',
      endDate: 'End Date',
      endTime: 'End Time',
      month1: 'January',
      month10: 'October',
      month11: 'November',
      month12: 'December',
      month2: 'February',
      month3: 'March',
      month4: 'April',
      month5: 'May',
      month6: 'June',
      month7: 'July',
      month8: 'August',
      month9: 'September',
      months: {
        apr: 'Apr',
        aug: 'Aug',
        dec: 'Dec',
        feb: 'Feb',
        jan: 'Jan',
        jul: 'Jul',
        jun: 'Jun',
        mar: 'Mar',
        may: 'May',
        nov: 'Nov',
        oct: 'Oct',
        sep: 'Sep',
      },
      nextMonth: 'Next Month',
      nextYear: 'Next Year',
      now: 'Now',
      prevMonth: 'Previous Month',
      prevYear: 'Previous Year',
      selectDate: 'Select date',
      selectTime: 'Select time',
      startDate: 'Start Date',
      startTime: 'Start Time',
      today: 'Today',
      week: 'week',
      weeks: {
        fri: 'Fri',
        mon: 'Mon',
        sat: 'Sat',
        sun: 'Sun',
        thu: 'Thu',
        tue: 'Tue',
        wed: 'Wed',
      },
      year: '',
    },
    empty: {
      description: 'No Data',
    },
    image: {
      error: 'FAILED',
    },
    messagebox: {
      cancel: 'Cancel',
      confirm: 'OK',
      error: 'Illegal input',
      title: 'Message',
    },
    pageHeader: {
      title: 'Back',
    },
    pagination: {
      goto: 'Go to',
      pageClassifier: '',
      pagesize: '/page',
      total: 'Total {total}',
    },
    popconfirm: {
      cancelButtonText: 'No',
      confirmButtonText: 'Yes',
    },
    select: {
      loading: 'Loading',
      noData: 'No data',
      noMatch: 'No matching data',
      placeholder: 'Select',
    },
    table: {
      clearFilter: 'All',
      confirmFilter: 'Confirm',
      emptyText: 'No Data',
      resetFilter: 'Reset',
      sumText: 'Sum',
    },
    transfer: {
      filterPlaceholder: 'Enter keyword',
      hasCheckedFormat: '{checked}/{total} checked',
      noCheckedFormat: '{total} items',
      noData: 'No data',
      noMatch: 'No matching data',
      titles: ['List 1', 'List 2'],
    },
    tree: {
      emptyText: 'No Data',
    },
    upload: {
      continue: 'Continue',
      delete: 'Delete',
      deleteTip: 'press delete to remove',
      preview: 'Preview',
    },
  },
  gao: '高い',
  gouMai: '買う',
  gouMaiChengGong: '購入が成功しました',
  guoJiHuoBiZhangHuLianXiZaiXianZhiChiFuWuJinHangPiPei:
    '国際通貨アカウントの照合についてはオンライン サポート サービスにお問い合わせください',
  home: {
    Application: 'アプリケーション',
    AvailableOnThe: '次のアプリで利用可能',
    CreditCard: '暗号通貨の預金',
    CreditCardInfo:
      '暗号通貨を預金に使用することで、セキュリティが強化され、迅速な取引処理が保証されます。',
    CryptocurrenciesListed: 'リストされた暗号通貨',
    GetStarted: '始めましょう',
    NewFeaturesInOnline: 'オンラインでの新機能',
    NewFeaturesInOnlineInfo: 'この完全なプラットフォームの素晴らしい機能を知ってください',
    RegisteredUsers: '登録ユーザー',
    allChains: 'All Chains',
    announcementClose: 'お知らせを閉じる',
    announcementLabel: 'お知らせ',
    announcementView: '詳細を見る',
    announcementAmount: '貸出金額',
    announcementAnnualRate: '年間利回り',
    announcementBelowMinimum: '{amount} USDT 未満',
    announcementCompoundInterest: '複利',
    announcementCurrentConfig: '現在の設定',
    announcementEarningMode: '利息計算方式',
    announcementRateNotice:
      '収益は現在の段階設定で計算されます。最終金額は資産ページと決済記録をご確認ください。',
    announcementRatesLoading: '現在の利回り段階を読み込み中…',
    announcementSettlement: '毎日の決済時刻',
    announcementSimpleInterest: '単利',
    announcementYieldEyebrow: '収益情報',
    announcementYieldIntro:
      '貸出金額が大きいほど年間利回りが高くなります。最初の段階未満でも参加できますが、利息は発生しません。',
    announcementYieldTitle: '現在の収益明細',
    appLicationInfo:
      'ロールブックを排除し、財務管理のための精密ツールを提供するモバイルバンキング。',
    billion: 'B',
    billionInfo: '平均24時間取引量',
    button1Title: '最低の取引手数料',
    button1Title1: 'すべての資産を一か所で取引',
    button1Title2: '外国為替、暗号通貨、株式、指数、商品',
    button2Title: '低金利と高額',
    button2Title1: '暗号通貨ローン',
    button2Title2: '担保なしで暗号通貨スポットを借りる',
    button3Title: 'シンプルで安定',
    button3Title1: 'スマートトレーディング',
    button3Title2: 'ワンクリックで収益プランを作成',
    button4Title: '世界中の子どもたちを助ける',
    button4Title1: 'NFTチャリティ',
    button4Title2: 'ユニセフを支援するためにNFTアートワークを購入',
    closeFeatured: 'Close featured',
    colApy: 'APY',
    colAsset: 'Asset',
    colChain: 'Chain',
    colTotalDeposits: 'Total Deposits',
    depositAction: 'Deposit',
    depositSubtitle: 'レンディングプールに流動性を提供して利息を得る',
    depositTitle: 'Defi Lending Pool',
    featured: 'Featured',
    filterAssets: 'Filter assets...',
    homeTitle: '350以上の暗号通貨を最高のプラットフォームで購入、取引、保有。',
    loading: 'Loading...',
    million: 'M',
    noMore: 'No more pools',
    noPools: 'No lending pools yet',
    noticeInfo: 'ウォレットはBTCをUSDに交換できます',
    noticeInfo1: 'デモアカウントで操作',
    periodDays: '{count} day | {count} days',
    sortApy: 'Sort: APY',
    sortTotalDeposits: 'Sort: Total Deposits',
  },
  huanKuanZhong: '返済中',
  huanYingShiYongWoMenLvHuoShuRongDeJinRongJiaoYiPingTaiYuQuanQiuTouZiZheYiQiTanSuoWeiLaiDeJinRongShiJie:
    '受賞歴のある当社の金融取引プラットフォームをぜひご利用いただき、世界の投資家とともに未来の金融世界を探索してください。',
  jiXiShiJian: '利息の発生時期',
  jiXuTouZi: '投資を続ける',
  jiangTuPianTuoFangDaoCiChuHuo: 'ここに画像をドラッグ アンド ドロップするか、',
  jieZhiShiJian: '締め切り',
  jiuMiMa: '以前のパスワード',
  juJueYuanYin: '拒否理由',
  kai: '開ける',
  lendingAssets: {
    authorizedBalance: '承認済み残高',
    availableAmount: '出金可能額',
    dailyOrders: '日次決済注文',
    dailyProfit: '日次収益',
    joinPool: 'プールに参加',
    loadMore: 'さらに読み込む',
    needAuth: 'レンディングプールに参加すると、残高と収益を確認できます',
    needLogin: '資産を確認するにはログインしてください',
    noOrders: '決済注文はまだありません',
    pageDesc: '承認済み残高、レンディング収益、日次決済注文を確認',
    poolEarnings: 'レンディングプール収益',
    todayEarnings: '本日の収益',
    totalEarnings: '累計収益',
    withdraw: '出金',
    withdrawRecords: '出金履歴',
    withdrawnAmount: '出金済額',
  },
  lendingContent: {
    rulesSecurity:
      "<p>This page describes <strong>interest accrual rules, settlement cadence, and security mechanisms</strong> for the lending pool. Please read carefully before participating.</p>\n\n<h2>1. Interest Rules</h2>\n<h3>1.1 Accrual Base</h3>\n<p>Earnings accrue on your <strong>authorized on-chain balance</strong> after Approve. Once authorized, the system reads your USDT / USDC (and other supported asset) allowance and balance as the principal reference for each settlement period.</p>\n\n<h3>1.2 Interest Rate</h3>\n<p>Settlement rates reference the associated pool's <strong>Supply APY</strong>, updated as on-chain market data syncs. APY includes base and reward components; the rate effective for each period applies at settlement time.</p>\n\n<h3>1.3 Settlement Cadence</h3>\n<ul>\n  <li><strong>Frequency:</strong> A yield settlement order is generated once daily;</li>\n  <li><strong>Order type:</strong> Period earnings (viewable under My Portfolio → Settlement Orders);</li>\n  <li><strong>Fields shown:</strong> Amount, token type (USDT / USDC), settlement time.</li>\n</ul>\n<p>Approximate daily amount ≈ Authorized balance × APY ÷ 365 (daily proration). Very small amounts may round to zero.</p>\n\n<h3>1.4 Total &amp; Today</h3>\n<p><strong>Total Earnings</strong> is the sum of historical settlements. <strong>Today</strong> reflects settlements from 00:00 to now (server time). Figures are based on system order records.</p>\n\n<h2>2. Authorization &amp; Security</h2>\n<h3>2.1 Non-Custodial</h3>\n<p>This service is <strong>non-custodial</strong>: we do not store private keys, seed phrases, or credentials that can move funds directly. All on-chain authorization requires confirmation in your wallet.</p>\n\n<h3>2.2 Authorization Scope</h3>\n<p>Joining a pool requires ERC-20 <strong>Approve</strong>, allowing the protocol contract to interact within your allowance. You should:</p>\n<ul>\n  <li>Confirm only authorization requests initiated from the official UI;</li>\n  <li>Periodically review and revoke unused approvals in your wallet;</li>\n  <li>Never approve unknown addresses or phishing sites.</li>\n</ul>\n\n<h3>2.3 Account &amp; API Security</h3>\n<ul>\n  <li>Client APIs use token authentication; sensitive actions require an active session;</li>\n  <li>Full-site HTTPS encryption;</li>\n  <li>Authorization and settlement records are retained for audit and queries.</li>\n</ul>\n\n<h2>3. On-Chain Protocol Security</h2>\n<ul>\n  <li>Underlying protocols use audited open-source smart contracts; deposit, borrow, and liquidation run on-chain;</li>\n  <li>Over-collateralization and liquidation help maintain solvency;</li>\n  <li>Pool TVL, APY, and utilization data from public sources may lag on-chain state by minutes.</li>\n</ul>\n\n<h2>4. User Responsibilities</h2>\n<ul>\n  <li>DeFi yields fluctuate; <strong>fixed returns are not guaranteed</strong>;</li>\n  <li>Stablecoins may de-peg under extreme conditions;</li>\n  <li>Network congestion may delay authorization or queries;</li>\n  <li>Never share private keys, seed phrases, or verification codes;</li>\n  <li>Stop immediately and contact support if you see suspicious links or approval prompts.</li>\n</ul>\n\n<h2>5. Revocation &amp; Exit</h2>\n<p>You may set token allowance to <strong>zero in your wallet</strong> to revoke Approve at any time. No new period earnings accrue after revocation; historical settlements remain queryable. Revocation does not change on-chain asset ownership—funds remain in your wallet address.</p>\n\n<p>— If rules change, the latest client display and settlement records prevail.</p>",
    whitepaper:
      '<p><strong>ドキュメントバージョン：</strong>V3.28 &nbsp;|&nbsp; <strong>公開日：</strong>2022年 &nbsp;|&nbsp; <strong>文書種別：</strong>製品ホワイトペーパーおよびセキュリティ評価概要</p>\n\n<h2>1. 概要</h2>\n<p>本レンディングプール（Lending Pool）は、分散型金融（DeFi）マネーマーケットプロトコル上に構築されたオンチェーン流動性貸借サービスモジュールです。オープンソースのスマートコントラクトとプログラム可能な金利モデルにより、ユーザーのデジタル資産を成熟したオンチェーン貸借市場に接続し、<strong>預金による利回り、担保付き借入、流動性の共有</strong>などの中核機能を実現します。</p>\n<p>本モジュールは日常の資金配分に人的介入を必要とせず、金利、キャパシティ、利用率などの主要指標はオンチェーン市場によってリアルタイムに決定され、複数ソースのデータ集約と定期同期により透明に表示されます。</p>\n\n<h2>2. 業界背景と製品ポジション</h2>\n<p>従来の貸借は信用評価と資金仲介を中央集権的な機関に依存しています。DeFi 貸借プロトコルはスマートコントラクトで需給を自動的にマッチングし、過剰担保と清算メカニズムによりシステムの支払能力を保護します。</p>\n<p>本レンディングプールモジュールの位置づけ：</p>\n<ul>\n  <li><strong>オンチェーンマネーマーケットゲートウェイ：</strong>複数チェーン・複数プロトコルのレンディングプールデータを集約；</li>\n  <li><strong>プログラムによる利回り分配：</strong>承認残高と市場 APY に基づき、固定スケジュールで自動決済；</li>\n  <li><strong>透明性と検証可能性：</strong>TVL、APY、利用率、LTV は公開オンチェーンデータに遡及可能；</li>\n  <li><strong>非カストディアル設計：</strong>資産承認とオンチェーン操作はユーザーのウォレットから開始。</li>\n</ul>\n\n<h2>3. システムアーキテクチャ</h2>\n<h3>3.1 アーキテクチャ概要</h3>\n<ul>\n  <li><strong>ユーザーインターフェース層：</strong>ウォレット接続、承認、プール閲覧、収益照会；</li>\n  <li><strong>ビジネスサービス層：</strong>認証、承認管理、利回り注文生成、多言語コンテンツ；</li>\n  <li><strong>データ集約層：</strong>公開 DeFi データソースから定期的に指標を同期；</li>\n  <li><strong>オンチェンプロトコル層：</strong>監査済みオープンソース貸借プロトコルが入出金ロジックを実行。</li>\n</ul>\n\n<h3>3.2 主要指標</h3>\n<table>\n  <thead>\n    <tr><th>指標</th><th>説明</th></tr>\n  </thead>\n  <tbody>\n    <tr><td>TVL</td><td>プール内資産の USD 建て総額；市場深度を反映</td></tr>\n    <tr><td>Supply APY</td><td>基本金利とプロトコル報酬による預金年利</td></tr>\n    <tr><td>Borrow APY</td><td>借り手が支払う年間コスト</td></tr>\n    <tr><td>利用率</td><td>借入済み資金と利用可能資金の比率</td></tr>\n    <tr><td>Max LTV</td><td>清算前の最大ローン・トゥ・バリュー比率</td></tr>\n    <tr><td>Supply / Borrow Cap</td><td>集中リスク管理のための資産別上限</td></tr>\n    <tr><td>Available Liquidity</td><td>即時借入可能な流動性</td></tr>\n  </tbody>\n</table>\n\n<h2>4. ユーザーフローと利回りメカニズム</h2>\n<ol>\n  <li><strong>ウォレット接続</strong>（Web3 ウォレット）；</li>\n  <li><strong>資産承認</strong>（USDT、USDC 等のオンチェーン Approve）；</li>\n  <li><strong>レンディングプールへの参加</strong>で利回り計算キューに登録；</li>\n  <li><strong>利回り決済</strong>を承認残高と市場金利に基づき毎日実行；</li>\n  <li><strong>資産照会</strong>は「マイポートフォリオ」で残高と決済履歴を確認。</li>\n</ol>\n<p><strong>過去の APY は将来のリターンを保証しません。</strong></p>\n\n<h3>4.3 手数料</h3>\n<h4>DeFi 稼ぎの手数料はどのように請求されますか？</h4>\n<p>オンチェーン取引では、申込や収益受取などスマートコントラクトとのやり取りに gas 手数料が必要です。一部の資産については、DeFi レンディングプールおよびボールト管理者が、実際に得た利益の一定割合をパフォーマンス手数料として請求する場合があります。元本には影響しません。</p>\n\n<h2>5. セキュリティ設計</h2>\n<ul>\n  <li>基盤プロトコルは監査済みオープンソースコントラクトを使用；</li>\n  <li>非カストディアルアーキテクチャ；秘密鍵・シードフレーズは保存しない；</li>\n  <li>必要最小限の Token Approve 権限；ウォレットでいつでも取消可能；</li>\n  <li>トークン認証、HTTPS、RBAC 管理、操作監査ログ。</li>\n</ul>\n\n<h2>6. セキュリティ評価概要</h2>\n<table>\n  <thead>\n    <tr><th>項目</th><th>結果</th><th>備考</th></tr>\n  </thead>\n  <tbody>\n    <tr><td>スマートコントラクト依存</td><td><strong>合格</strong></td><td>公開監査済み DeFi プロトコル</td></tr>\n    <tr><td>非カストディアルと鍵管理</td><td><strong>合格</strong></td><td>秘密鍵の保存なし</td></tr>\n    <tr><td>API と認証</td><td><strong>合格</strong></td><td>トークン認証と HTTPS 実装済み</td></tr>\n    <tr><td>データ同期と一貫性</td><td><strong>合格</strong></td><td>定期同期とスナップショット</td></tr>\n    <tr><td>利回り決済ロジック</td><td><strong>合格</strong></td><td>明確なルール；監査可能な注文</td></tr>\n  </tbody>\n</table>\n\n<h2>7. リスク開示</h2>\n<ul>\n  <li><strong>スマートコントラクトリスク：</strong>未発見の脆弱性が存在する可能性；</li>\n  <li><strong>市場リスク：</strong>APY は大きく変動する可能性；</li>\n  <li><strong>清算リスク：</strong>担保価格の急落で清算が発生する可能性；</li>\n  <li><strong>ステーブルコイン脱ペグリスク：</strong>USDT/USDC が $1.00 から乖離する可能性；</li>\n  <li><strong>規制リスク：</strong>DeFi 規制は各国で進化中。</li>\n</ul>\n<p><strong>本モジュールは投資助言を提供せず、固定リターンを保証しません。</strong></p>\n\n<h2>8. 用語集</h2>\n<ul>\n  <li><strong>APY：</strong>年利（Annual Percentage Yield）；</li>\n  <li><strong>TVL：</strong>総ロック額（Total Value Locked）；</li>\n  <li><strong>LTV：</strong>ローン・トゥ・バリュー比率；</li>\n  <li><strong>Approve：</strong>ERC-20 トークン承認；</li>\n  <li><strong>清算（Liquidation）：</strong>担保不足時に自動売却。</li>\n</ul>\n\n<p>— 本ドキュメントは情報提供のみを目的とし、法的・財務的・投資上の助言を構成しません。オンチェーンデータはブロックエクスプローラーおよび公式プロトコルインターフェースでご確認ください。</p>',
    yieldLadder:
      "<p><strong>Defi Lending Pool</strong> offers a transparent, tiered yield program for authorized stablecoin deposits. Your daily earnings are determined by your authorized balance (USD equivalent) and the applicable tier rate shown below. Tier rates are loaded from the platform configuration in real time.</p>\n\n<h2>1. How Yield Works</h2>\n<p>After you authorize USDT or USDC through your Web3 wallet on <strong>Defi Lending Pool</strong>, the platform uses your on-chain authorized balance as the yield base. Each calendar day, the system generates settlement orders based on the rules below (USDT and USDC are calculated and compounded separately):</p>\n<ul>\n  <li><strong>On-chain principal:</strong> Your authorized stablecoin balance at settlement time (USD equivalent);</li>\n  <li><strong>Tier rate:</strong> The daily yield rate matching your on-chain balance range in the tier table below;</li>\n  <li><strong>Compound mode (default):</strong> Daily earnings ≈ (On-chain balance + accumulated unredeemed earnings for that token) × Daily rate ÷ 100;</li>\n  <li><strong>Simple mode (if enabled):</strong> Daily earnings ≈ On-chain balance × Daily rate ÷ 100.</li>\n</ul>\n<p>Withdrawing platform earnings only affects your withdrawable balance and compound base — <strong>it does not change your on-chain wallet balance</strong>. Settlement runs <strong>4 times per day</strong>. Earnings accumulate in your account and can be viewed under <strong>Assets → Settlement Orders</strong>. Past performance does not guarantee future returns.</p>\n\n<h2>2. Yield Tier Table</h2>\n<p>The table below shows the current tier structure on <strong>Defi Lending Pool</strong>. Higher authorized balances qualify for higher indicative daily rates. Figures are <strong>daily percentages</strong>, not annualized APY.</p>\n<!-- YIELD_TIER_TABLE -->\n<p><strong>Note:</strong> Your tier is determined automatically by your <strong>on-chain authorized balance</strong> at each daily settlement. If your on-chain balance moves into a different range, the next settlement will apply the corresponding tier rate. In compound mode, accumulated unredeemed earnings participate in yield calculation but do not change tier matching.</p>\n\n<h2>3. Tier Matching Rules</h2>\n<ul>\n  <li>Only <strong>authorized (Approved)</strong> USDT / USDC balances participate in yield calculation;</li>\n  <li>Balances below the minimum tier threshold do not generate settlement orders;</li>\n  <li>Each tier applies to a closed USD balance range — the system matches the single tier that contains your balance;</li>\n  <li>Where a tier shows a rate range, settlement uses the midpoint of that range;</li>\n  <li>Tier configuration may be updated by platform operators; changes apply to future settlements only.</li>\n</ul>\n\n<h2>4. Settlement &amp; Display</h2>\n<h3>4.1 Settlement Cycle</h3>\n<ul>\n  <li><strong>Frequency:</strong> Four settlement orders per day per authorized asset;</li>\n  <li><strong>First settlement:</strong> Wallets authorized on the same day begin earning from the next calendar day;</li>\n  <li><strong>Order fields:</strong> Settlement amount, token type (USDT / USDC), applied rate, and timestamp.</li>\n</ul>\n<h3>4.2 Portfolio Metrics</h3>\n<p>On the <strong>Assets</strong> page you can track <strong>Total Earnings</strong> (historical sum) and <strong>Today's Earnings</strong> (current-day settlements). All figures are based on system order records.</p>\n\n<h2>5. Getting Started on Defi Lending Pool</h2>\n<ol>\n  <li>Log in and connect your Web3 wallet (MetaMask or compatible);</li>\n  <li>Tap <strong>Join Now</strong> in the sidebar and choose USDT or USDC;</li>\n  <li>Confirm the on-chain <strong>Approve</strong> transaction in your wallet;</li>\n  <li>Once authorized, your balance is matched to a yield tier automatically;</li>\n  <li>Check daily settlement orders and cumulative earnings on the <strong>Assets</strong> page.</li>\n</ol>\n\n<h2>6. Risk Disclosure</h2>\n<p><strong>Defi Lending Pool</strong> operates in a non-custodial model — the platform never holds your private keys. On-chain authorization carries smart-contract and market risks. Tier rates, pool capacity, and settlement outcomes may change. Please review the <strong>Rules &amp; Security</strong> page before participating.</p>\n\n<p>— Tier rates are synced from platform settings. Table values are indicative; final amounts appear in your settlement order history.</p>",
  },
  lendingDetail: {
    assetOn: 'Asset on',
    availableLiquidity: 'Available Liquidity',
    avgApy30d: '30d Avg APY',
    baseApy: 'Base APY',
    baseRates: 'Base Rates',
    borrow: 'Borrow',
    borrowDesc: 'Borrow {symbol} against your deposited collateral',
    borrowHint: 'Borrow via',
    borrowMarkets: 'Borrow Markets',
    borrowSoon: 'On-chain borrow coming soon',
    capacityFilled: 'Capacity Filled',
    chain: 'Chain',
    chains: 'Chains',
    collateral: 'Collateral',
    deposit: 'Deposit',
    depositApy: 'Deposit APY',
    depositDesc: 'Deposit {symbol} to earn yield',
    depositMarkets: 'Deposit Markets',
    depositSoon: 'On-chain deposit coming soon',
    exposure: 'Exposure',
    loading: 'Loading...',
    notEligible: 'Not eligible',
    notFound: 'Lending pool not found',
    protocol: 'Protocol',
    rewardApy: 'Reward APY',
    stablecoin: 'Stablecoin',
    stablecoinPrice: 'About $1.00',
    title: 'Pool Detail',
    totalDeposits: 'Total Deposits',
  },
  lendingIdentity: {
    needLogin: '本人確認の前にログインしてください',
    needVerifyHint: 'レンディングプールに参加する前に本人確認を完了してください',
    pageDesc: '本人確認を完了すると、レンディングプールに参加して預入・借入サービスを利用できます',
    pendingHint: '本人確認は審査中です。しばらくお待ちください',
  },
  lendingMenu: {
    assets: '資産',
    chooseDepositAsset: '預入する資産を選択',
    chooseDepositHint: '資産をレンディングプールに預けて収益を得て、借入も可能になります',
    copyUid: 'UIDをコピー',
    customerService: 'Customer Service',
    depositAssetAction: '{symbol} を預入',
    earnings: '収益方法',
    empty: 'コンテンツがありません',
    explore: '探索',
    footerDesc:
      'オープンソースのスマートコントラクトを基盤とした次世代オンチェーン貨幣市場。プログラムによるルールが人的管理に代わり、世界中のWeb3ユーザーに安全で透明な流動性の預入・貸出サービスを提供します。',
    getStarted: '今すぐ参加',
    home: 'ホーム',
    identityVerification: '本人確認',
    intro: '概要',
    language: '言語',
    noAssetPool: 'この資産のレンディングプールが見つかりません',
    rulesSecurity: 'Rules & Security',
    security: 'セキュリティ',
    theme: '外観',
    uid: 'UID',
    whitepaper: 'ホワイトペーパー',
    yieldLadder: '収益階層',
  },
  lendingTheme: {
    auto: 'システム',
    dark: 'ダーク',
    light: 'ライト',
    title: '外観',
  },
  lendingYieldLadder: {
    balance: '1件あたりの貸付元本（USDT）',
    compoundInterest: '複利',
    earningMode: '収益表示方式：{mode}',
    empty: '利率階層はまだ設定されていません',
    loading: '階層別利率を読み込んでいます…',
    noteFixed: 'この階層の固定日次利率で毎日決済',
    noteRange: '区間上限の日次利率で毎日決済',
    notes: '説明',
    rate: '日次収益率の範囲',
    settlementHours: '設定された決済時刻：{hours}',
    simpleInterest: '単利',
  },
  liangCiMiMaBuYiZhi: '2 つのパスワードが矛盾しています',
  loan: {
    Browse: '閲覧する',
    address: '住所:',
    birthdate: '生年月日:',
    borrow: '借りる',
    borrowNow: '今すぐ借りる',
    borrowPlaceholder: '借りたい...',
    browse: '閲覧する',
    checkIn: '提出が完了しました',
    confirm: '確認',
    continue: '続ける',
    country: '国:',
    dailyRate: '日次利率',
    days: '日',
    document: '書類:',
    done: '完了！',
    driverLicense: '運転免許証',
    dropHere: 'ここにイメージをドロップ',
    ensure: '確認する',
    female: '女性',
    firstName: '名前:',
    idCard: 'IDカード',
    inHand: '手持ちの',
    lastName: '姓:',
    launchCamera: 'カメラを起動する',
    loanAgreement: 'ローン契約',
    loanAmount: 'ローン金額',
    loanDetail: 'ローン詳細',
    loanTerm: 'ローン期間',
    male: '男性',
    notVerifyBtn: '認証を開始',
    notVerifyTip: '本人確認をして、より多くのローン額を得る！',
    or: 'または',
    passport: 'パスポート',
    pendingReview: '審査待ち',
    phone: '電話番号:',
    phonePlaceholder: '電話番号を入力してください...',
    reSign: '再署名',
    resubmit: '再提出する',
    sex: '性別:',
    sign: '署名',
    signTip: '確認して署名してください',
    signed: '署名済み',
    startVerfication: '確認を開始する',
    submit: '送信する',
    supports: '対応形式: JPG、JPEG2000、PNG',
    takePhoto: '写真を撮る',
    term: 'ローン期間（日）',
    tipIdCardBack: 'IDカードの裏面をフレームに置いてください',
    tipIdCardFront: 'IDカードの表面をフレームに置いてください',
    tipNotPass:
      'KYC申請が審査に通過できなかったことをお詫び申し上げます。正しい申請資料を再提出してKYCの審査を完了させてください。ご質問やご相談がある場合は、お気軽にカスタマーサポートチームにお問い合わせください。',
    tipTakePhoto: '以下のものを写真に撮ってください：',
    tipVerifiedSuccess:
      'おめでとうございます！あなたのKYC申請が承認されました。高度なサービスをご利用いただけます。',
    tipWaitForResult:
      'KYC書類を提出していただきありがとうございます。弊社チームによる情報確認には48時間程度かかる場合があります。結果が出るまでしばらくお待ちください。',
    title: 'ローンアカウント',
    totalAmount: '利息総額',
    verifiedSuccessfully: '正常に確認されました',
    verifiedUnsuccessfully: '確認に失敗しました',
    verifyBtn: '認証に成功しました',
    verifyTip: '投資を確保するための即時資金を入手！',
  },
  login: {
    btnContinueFacebook: 'Facebookで続行',
    btnContinueGoogle: 'Googleで続行',
    btnLogin: 'ログイン',
    btnLoginFacebook: 'Facebookでログイン',
    btnLoginGoogle: 'Googleでログイン',
    btnNext: '次へ',
    btnRecovery: 'リカバリー',
    btnRecoveryPsd: 'パスワードの回復',
    btnRegister: '登録',
    btnRegisterFacebook: 'Facebookで登録',
    btnRegisterGoogle: 'Googleで登録',
    btnSend: '送信する',
    btnSignup: 'メールでサインアップ',
    email: 'メール',
    emailPlaceholder: 'メールアドレスを入力（例: name@example.com）',
    emailTips: 'このメールアドレスは既に登録されています',
    hasAccount: 'すでにアカウントをお持ちですか？',
    hasNotAccount: 'アカウントを持っていませんか？',
    inputCode: '認証コードを入力してください',
    inputEmail: 'メールアドレスを入力してください',
    inputPassword: 'パスワードを入力してください',
    inputPhone: 'メールアドレスを入力してください',
    inputUsernameOrEmail: 'ユーザー名またはメールを入力してください',
    labelEmail: 'メール:',
    labelEmailCode: '認証コード:',
    labelPsd: 'パスワード:',
    labelPsdNew: '新しいパスワード:',
    labelPsdRepeat: 'パスワードの確認:',
    labelUsername: 'ユーザー名:',
    labelUsernameOrEmail: 'ユーザー名またはメール:',
    phone: '郵便：',
    phoneTips: 'このメールアドレスは登録されています',
    starLogin: 'ログインから始めましょう！',
    starRegist: '登録から始めましょう！',
    starReset: 'メールでリカバリーしましょう！',
    tipRegisterContent:
      '登録を完了し、エキサイティングな投資機会の世界へのゲートウェイを解放し、財務成功と成長への道を築きます！',
    tipRegisterTitle: 'サインアップして、繁栄する投資の旅に乗り出しましょう！',
    useEmailRegister: 'メールで登録する',
    usePhoneRegister: '電話番号で登録する',
    username: 'ユーザー名',
    usernameOptional: 'ユーザー名（任意・空欄の場合はメールと同じ）',
    usernameTips: 'このユーザー名はすでに存在します。',
    welcome: 'ようこそ',
  },
  navBottom: {
    bottomCompany: '会社',
    bottomCompanyItem1: '私たちについて',
    bottomCompanyItem2: 'ライセンス監督',
    bottomCompanyItem3: 'ヘルプセンター',
    bottomCompanyItem4: 'オンラインサポート',
    bottomOther: '声明',
    bottomOtherItem1: '法的情報',
    bottomOtherItem2: '免責事項',
    bottomOtherItem3: 'リスク警告',
    bottomOtherItem4: 'クッキーポリシー',
    bottomOtherItem5: '広告について',
    bottomPolicy: 'ポリシー',
    bottomPolicyItem1: '利用規約',
    bottomPolicyItem2: 'プライバシーポリシー',
    bottomProduct: '製品',
    bottomProductItem1: '市場',
    bottomProductItem2: '投資と貸付',
    bottomProductItem3: 'チャリティ用NFT',
    bottomProductItem4: 'スマート取引',
  },
  navTab: {
    btnLogin: 'ログイン',
    btnSignup: 'サインアップ',
    language: '言語',
    languageTips: '言語と地域を選択',
    tabMenu1: 'ホーム',
    tabMenu2: 'マーケット',
    tabMenu3: 'スマート取引',
    tabMenu4: 'ローン',
    tabMenu5: 'NFT',
    tabMenu6: 'アカウント',
  },
  ninShuRuDeZhiSunJiaGeBuHeLi: '入力したストップロス価格が不当です',
  ninShuRuDeZhiYingJiaGeBuHeLi: '入力したテイクプロフィット価格は不当です',
  notifications: {
    deposit: {
      content:
        '尊敬するユーザー様、\u0024{amount}USDの入金を受け取り、アカウント残高に\u0024{amount}を正常に追加いたしました。',
      title: '入金通知',
    },
    kyc: {
      content:
        '尊敬するユーザー様、KYC認証に合格されました。KYCプロセスが完了し、より高いレベルのサービスをお楽しみいただけます。',
      title: 'KYC認証通過',
    },
    loan: {
      content:
        '尊敬するお客様、おめでとうございます。\u0024{amount}USDのローン申請が承認されました。申請を審査し承認いたしました。ローン金額がアカウントに入金されました。アカウントにログインして詳細をご確認ください。',
      title: 'ローン承認',
    },
    repayment: {
      content:
        '尊敬するユーザー様、\u0024{amount}USDの返済を正常に受け取りました。いつもご支援いただき、ありがとうございます。',
      title: '返済成功',
    },
    withdraw: {
      content:
        '尊敬するユーザー様、\u0024{amount}の出金申請が正常に処理されました。関連情報にご注意いただき、タイムリーにご確認ください。',
      failed: {
        content:
          '尊敬するユーザー様、\u0024{amount}の出金リクエストが失敗しました。出金詳細を慎重にご確認いただき、速やかにオンラインサポートにお問い合わせください。',
        title: '出金通知',
      },
      title: '出金通知',
    },
  },
  ntfs: {
    Address: 'アドレス',
    AllMoneyCharities: 'NFTの販売から得られるすべてのお金はユニセフのチャリティに寄付されます',
    BuyNFT: 'NFTアートを購入し、世界中の子供たちを助けましょう！',
    BuyNow: '今すぐ購入',
    Chain: 'チェーン',
    Confirm: '確認',
    Creator: 'クリエイター',
    CumulativeDonation: '累計寄付',
    CurrentBid: '現在の入札',
    Markets: 'マーケット',
    MyNFTs: '私のNFT',
    NFTs: 'NFT',
    NFTsDetail: 'NFT詳細',
    PlaceABid: '入札する',
    RemainingTime: '残り時間',
    Successful: '成功',
    ThanksDonation: '寄付していただきありがとうございます',
    Thisaddress: 'このアイテムはあなたのウォレットアドレスに送られます',
    Verified: '確認済み',
    andUNICEF: 'そしてお金はユニセフに寄付されます',
    charity: 'チャリティ',
  },
  null: '未知の間違い',
  qingQieHuanWeiZhenShiZhangHuCaoZuo: 'リアルアカウント運用に切り替えてください',
  qingShangChuanPingZheng: '証明書をアップロードしてください',
  qingShuRuDiZhi: '住所を入力してください',
  qingShuRuShouJiHao: 'メールアドレスを入力してください',
  qingShuRuTouZiJinE: '投資金額を入力してください',
  qingShuRuYanZhengMa: '確認コードを入力してください',
  qingShuRuZhengQueDeJinE: '正しい金額を入力してください',
  qingShuRuZhengQueDeYouXiang: '有効なメールアドレスを入力してください',
  qingShuRuZhiSunJiaGe: 'ストップロス価格を入力してください',
  qingShuRuZhiYingJiaGe: 'テイクプロフィット価格を入力してください',
  qingTianXieWanZhengXinXi: '完全な情報を入力してください',
  qingZaiCiShuRuMiMa: 'パスワードをもう一度入力してください',
  queRenMiMa: 'パスワードを認証する',
  repaySuccess: '返済成功',
  ri: '日',
  riLiShuai: '日利率:',
  search: {
    SearchHere: 'ここで検索',
  },
  shangChuanShiBaiQingZhongShi: 'アップロードに失敗しました。もう一度お試しください',
  shenHeBuTongGuo: '監査に合格しませんでした',
  shou: '受け取る',
  shouJiHao: '郵便',
  shouXuFeiShiJiDaoZhangJinE: '手数料／実際の受取金額',
  shouYiZhong: '所得',
  shouYiZhuangTai: '収入状況',
  shuRuNinDeDianHuaHaoMa: '電話番号を入力してください...',
  souSuo: '検索...',
  tiJiaoChengGong: '正常に送信されました',
  tiJiaoChongZhiPingZheng: 'リチャージバウチャーを送信する',
  tiKuanFangShi: '出金方法',
  tiXian: '撤回する',
  tiXianDiZhi: '出金アドレス',
  tiXianShiJian: '出金時間',
  tiXianXuYao_3DeShouXuFeiXuYaoWangLuoJieDianQueRenHouCaiNengRuZhangQingBuYaoJiangJiaMiHuoBiZhuanGeiMoShengRen:
    '出金には {rate}% の手数料がかかり、アカウントに入金する前にネットワーク ノードからの確認が必要です。暗号通貨を見知らぬ人に送金しないでください。',
  toast: {
    UnreasonablePriceProfitLoss: 'ストップ・プロフィットとストップ・ロスの不合理な価格設定',
    buyNumbers: '購入数量を入力してください',
    copyError: 'コピー失敗！',
    copySuccess: 'コピー成功！',
    email: 'メールアドレスを入力してください',
    inputAll: 'データ入力が完全ではありません',
    logOut: 'ログアウト',
    noData: 'これ以上のデータはありません',
    notAddress: '住所を入力してください',
    notAmount: '金額を入力してください',
    notEmail: 'Eメールの形式が正しくありません',
    notImage: '画像形式が正しくありません',
    notLoanAmount: 'ローン金額を入力してください',
    notSigned: '未署名',
    notSmartAmount: 'スマート金額を入力してください',
    notSupportMedia: 'ユーザーメディアへのアクセスはサポートされていません',
    notVerify: 'KYC認証を実行してください',
    notWithdrawAmount: '引き出し金額を入力してください',
    nothingfound: 'まだ何も見つかりません！',
    password: 'パスワードを入力してください',
    passwordNotSame: 'パスワードの入力が一致しません',
    passwordRepeat: 'パスワードを確認してください',
    uploadImage: '必要な画像をアップロードしてください',
    userName: 'ユーザー名を入力してください',
  },
  tongChangXuYaoNinDeShouJiHaoYongHuMingMiMaDengJiBenXinXiYouShiHuanXuYaoGeRenXinXiHeLianXiXinXi:
    '通常、電子メール、ユーザー名、パスワードなどの基本情報が必要ですが、場合によっては個人情報や連絡先情報も必要です。',
  touZiShiJian: '投資時間',
  touZiZhouQi: '投資サイクル',
  tuPianDaXiaoBuNengChaoGuo_2mb: '画像サイズは 2MB を超えることはできません。',
  tuPianDaXiaoBuNengChaoGuo_5m: '画像サイズは 50MB を超えることはできません。',
  uploadfailed: 'アップロード失敗',
  usdtZuiDiChongZhiJinewei_120: '{name} の最低入金額は {limit} です',
  waiHuiZiDongJiaoYiLiangHuaShiYiZhongLiYongJiSuanJiChengXuHeSuanFaZiDongZhiHangJiaoYiCeLveDeFangFaGaiFangFaShiYongLiShiShuJuJiShuZhiBiaoTongJiMoXingHeQiTaFenXiGongJuLaiShiBieJiaoYiXinHaoBingZaiZhiHangJiaoYiShiZiDongZhiHangZheXieXinHaoWaiHuiZiDongJiaoYiLiangHuaKeYiBangZhuJiaoYiZheXiaoChuQingXuYingXiangJianShaoCuoWuJiaoYiTiGaoJiaoYiXiaoShuaiHeYiZhiXingDanShiZiDongWaiHuiJiaoYiLiangHuaYeCunZaiYiXieQianZaiDeFengXianHeJuXianXingLiRuZiDongJiaoYiChengXuKeNengWuFaShiYingShiChangBianHuaJiaoYiChengXuHeSuanFaDeZhiLiangHeYouXiaoXingZaiHenDaChengDuShangQuJueYuLiShiShuJuDeKeKaoXingHeYouXiaoXingCiWaiZiDongJiaoYiHuanKeNengCunZaiJiShuFengXianRuDianNaoGuZhangWangLuoZhongDuanDengYinCiZaiShiYongWaiHuiZiDongJiaoYiLiangHuaQianTouZiZheXuYaoZiXiPingGuZiJiDeJiaoYiMuBiaoFengXianChengShouNengLiHeJiShuNengLiXuanZeKeKaoDeJiaoYiPingTaiJiaoYiPingTaiHeZiDongJiaoYiChengXuZuiZhongYaoDeShiTouZiZheYingShiZhongBaoChiJinShenBingCaiQuShiDangDeFengXianGuanLiCuoShiLaiBaoHuTaMenDeTouZi:
    '外国為替自動取引定量化は、コンピュータープログラムとアルゴリズムを使用して取引戦略を自動的に実行する方法です。\nこの方法では、履歴データ、テクニカル指標、統計モデル、その他の分析ツールを使用して取引シグナルを特定し、取引実行時にこれらのシグナルを自動的に実行します。\n外国為替の自動取引定量化は、トレーダーが感情の影響を排除し、誤った取引を減らし、取引の効率と一貫性を向上させるのに役立ちます。\nただし、FX取引の自動定量化には潜在的なリスクと制限もいくつかあります。\nたとえば、自動取引プログラムは市場の変化に適応できない場合があり、取引プログラムとアルゴリズムの品質と有効性は履歴データの信頼性と有効性に大きく依存します。\nさらに、自動取引にはコンピューターの障害やネットワークの中断などの技術的リスクが伴う可能性もあります。そのため、投資家は自動外国為替取引定量化を使用する前に、取引の目的、リスク許容度、技術的能力を慎重に評価し、信頼できる取引定量化を選択する必要があります。取引プラットフォーム。\n取引プラットフォームと自動取引プログラム。\n最も重要なことは、投資家は常に注意を払い、投資を保護するために適切なリスク管理措置を講じるべきであるということです。',
  wallet: {
    activate: '有効化',
    authFailed: '認証に失敗しました',
    authSuccess: '認証に成功しました',
    authorized: '認証済み',
    connectFailed: 'ウォレットの接続に失敗しました',
    connectWallet: 'ウォレットを接続',
    connecting: '接続中...',
    justCanWallet: 'このサイトは分散型アプリ（Dapps）からのアクセスのみを許可しています',
    networkNotSupported:
      '現在のネットワークはサポートされていません。対応するネットワークに切り替えてください',
    noWalletDetected:
      'ウォレットが検出されませんでした。MetaMask または TronLink をインストールしてください。',
    pleaseConnectWallet: 'ウォレットを接続してください',
    status: 'ウォレットの状態',
    testnetDisabled: 'テストネットは無効です。メインネットを使用してください',
    transactionCancelled: '取引がキャンセルされました',
    unauthorized: '未認証',
    userCancelled: 'ユーザーが操作をキャンセルしました',
  },
  wangLuoChaoShiQingQuDingDanLieBiaoChaKanGaiDingDan:
    'ネットワークタイムアウト。注文リストにアクセスして注文を表示してください。',
  weiKaiQiZhiNengJiaoYi: 'インテリジェント取引が有効になっていません',
  weiRenZheng: '認定されていない',
  weiShiMoWoXuYaoZhuCeYiGeZhangHu: 'なぜアカウントに登録する必要があるのですか?',
  weiTongGuo: '不合格',
  woDeZhuCeXinXiHuiBeiBaoMiMa: '私の登録情報は秘密に保たれますか?',
  woKeYiGengGaiWoDeZhuCeXinXiMa: '登録情報を変更できますか?',
  woKeYiZhuCeDuoGeZhangHuMa: '複数のアカウントを登録できますか?',
  xiaCiShouYiShiJian: '次回の収益時間',
  xiaDanChengGong: '正常に注文されました',
  xinGongNengShangXian: '新機能がオンラインに登場！',
  xinMiMa: '新しいパスワード',
  yanShiZhangHaoBuNengShiYongGaiGongNeng: 'デモアカウントではこの機能を使用できません',
  yanShiZhangHuBuNengShiYongZhiNengJiaoYi: 'デモ口座ではインテリジェント取引を使用できません',
  yanShiZhangHuYiJinYong: 'デモアカウントが無効になっています',
  yiDaoQi: '期限切れになる',
  yiFenRun: '利益は山分けされました',
  yiFenRunTianShu: '利益分配日数',
  yiHuanKuan: '返済済み',
  yiJuJue: '拒否されました',
  yiQieHuanWeiXuNiZhangHu: 'バーチャルアカウントに切り替えました',
  yiQieHuanWeiZhenShiZhangHu: 'リアルアカウントに切り替えました',
  yiRenZheng: '検証済み',
  yiWanCheng: '完了しました',
  yiXieWangZhanKeNengYunXuYongHuZhuCeDuoGeZhangHuDanDaDuoShuWangZhanZhiYunXuMeiGeYongHuZhuCeYiGeZhangHuRuGuoNinChangShiZhuCeDuoGeZhangHuNinDeZhangHuKeNengHuiBeiJinZhiHuoShanChu:
    '一部の Web サイトではユーザーが複数のアカウントを登録できる場合がありますが、ほとんどの Web サイトでは各ユーザーが 1 つのアカウントしか登録できません。\n複数のアカウントを登録しようとすると、アカウントが禁止または削除される場合があります。',
  zhangFu: '増加',
  zhenFu: '振幅',
  zhuCeChengGong: '登録完了',
  zhuCeZhangHuKeYiRangNinGengFangBianDiShiYongWangZhanHuoYingYongChengXuDeGongNengBingKeYiBaoHuNinDeGeRenXinXi:
    'アカウントを登録すると、サイトまたはアプリケーションの機能をより便利に使用できるようになり、個人情報が保護されます。',
  zhuCeZhangHuXuYaoShiMoXinXi: 'アカウントの登録にはどのような情報が必要ですか?',
  zongLiXi: '利息総額',
  zuiDiJia: '最低価格',
}
